import { Wordmark } from "./wordmark";

/** Used only while startup, authentication or a route is actually loading. */
export function TenureLoading({
  embedded = false,
}: Readonly<{ embedded?: boolean }>) {
  return (
    <div
      className={`tenure-loading${embedded ? " tenure-loading-embedded" : ""}`}
      role="status"
      aria-label="Loading TENURE"
    >
      <div className="tenure-loading-monument">
        <Wordmark size="lg" />
        <video
          className="tenure-loading-film"
          src="/assets/brand/tenure-enduring.mp4"
          poster="/assets/brand/tenure-enduring-poster.jpg"
          autoPlay
          muted
          playsInline
          preload="auto"
          aria-hidden="true"
          tabIndex={-1}
        />
      </div>
      <p className="tenure-loading-statement">
        Analysis built to stand the test of time.
      </p>
      <p className="tenure-loading-status">Preparing your workspace</p>
    </div>
  );
}
